export const breakpoints = {
    phone:        '300px',
    phoneWide:   '480px',
    phablet:      '560px',
    tabletSmall: '640px',
    tablet:       '768px',
    tabletWide:  '1024px',
    desktop:      '1248px',
    desktopWide: '1440px'
};